module.exports = __webpack_public_path__ + "static/img/8.14217ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/benjyfishy/8.png
// module id = A8pD
// module chunks = 35